let sharedServicesUrl = null;
const setSharedServicesUrl = (url) => {
  sharedServicesUrl = url;
};
export {
  setSharedServicesUrl,
  sharedServicesUrl
};
